import { BunkerStemAccountTypes, BunkerStemSuppliedAsPartOf, FixtureTypes } from './constants';
import { Values } from './objectEnums';

export const getBunkerStemParcelDescription = (
	contractType: Values<typeof FixtureTypes>,
	paidBy: string | null,
	rebillTo: string | null,
	suppliedAsPartOf: BunkerStemSuppliedAsPartOf | null,
): string => {
	const isTcOut = contractType === FixtureTypes.TC_OUT;
	const isVcOutOrTcOut = contractType === FixtureTypes.SPOT || contractType === FixtureTypes.TC_OUT;

	if (
		isVcOutOrTcOut &&
		paidBy === BunkerStemAccountTypes.SELF && 
		rebillTo === null &&
		suppliedAsPartOf === null
	) {
		return 'Normal bunkering for your own account';
	}

	if (
		isTcOut &&
		paidBy === BunkerStemAccountTypes.CHARTERER && 
		rebillTo === null &&
		suppliedAsPartOf === null
	) {
		return 'Bunkering by charterer during TC OUT contract (on hire)';
	}

	if (
		isVcOutOrTcOut &&
		paidBy === BunkerStemAccountTypes.TC_IN_OWNER && 
		rebillTo === null &&
		suppliedAsPartOf === null
	) {
		return 'Stem by TC IN head owners';
	}

	if (
		isVcOutOrTcOut && 
		paidBy === BunkerStemAccountTypes.SELF && 
		rebillTo === BunkerStemAccountTypes.TC_IN_OWNER && 
		suppliedAsPartOf === null
	) {
		return 'Stem obo. TC IN head owners';
	}

	if (
		isVcOutOrTcOut && 
		paidBy === BunkerStemAccountTypes.SELF && 
		rebillTo === BunkerStemAccountTypes.TC_IN_OWNER && 
		suppliedAsPartOf === BunkerStemSuppliedAsPartOf.TC_IN_DELIVERY
	) {
		return 'Stem obo TC-In owners to meet BOD quantities';
	}

	if (
		isVcOutOrTcOut && 
		paidBy === BunkerStemAccountTypes.TC_IN_OWNER && 
		rebillTo === null && 
		suppliedAsPartOf === BunkerStemSuppliedAsPartOf.TC_IN_DELIVERY
	) {
		return 'TC-In owners stem to meet BOD quantities';
	}

	if (
		isTcOut && 
		paidBy === BunkerStemAccountTypes.CHARTERER && 
		rebillTo === BunkerStemAccountTypes.TC_IN_OWNER && 
		suppliedAsPartOf === BunkerStemSuppliedAsPartOf.TC_IN_DELIVERY
	) {
		return 'TC-Out charterer stemming on behalf of TC-In Owners for Delivery (passing directly through us)';
	}

	if (
		isTcOut && 
		paidBy === BunkerStemAccountTypes.SELF && 
		rebillTo === BunkerStemAccountTypes.CHARTERER && 
		suppliedAsPartOf === BunkerStemSuppliedAsPartOf.TC_OUT_REDELIVERY
	) {
		return 'TC-Out chrts stem to reach TC OUT BOR';
	}

	if (
		isTcOut && 
		paidBy === BunkerStemAccountTypes.SELF && 
		rebillTo === BunkerStemAccountTypes.CHARTERER && 
		suppliedAsPartOf === null
	) {
		return 'TC-Out chrts stem with TC-Out owners to prepare for future voyages';
	}

	if (
		isTcOut && 
		paidBy === BunkerStemAccountTypes.SELF && 
		rebillTo === null && 
		suppliedAsPartOf === BunkerStemSuppliedAsPartOf.TC_OUT_DELIVERY
	) {
		return 'Our stem to meet shortfall on BOD for TC-Out';
	}

	if (
		isTcOut && 
		paidBy === BunkerStemAccountTypes.CHARTERER && 
		rebillTo === BunkerStemAccountTypes.SELF && 
		suppliedAsPartOf === BunkerStemSuppliedAsPartOf.TC_OUT_DELIVERY
	) {
		return 'TC Out charterer stem on our behalf to make up for shortfall on TC OUT delivery (BOD)';
	}

	return '-';
};
